import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaiairporttopunecab() {



const cardData = {
  keyword: " Mumbai Airport to Pune Cabs",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai Airport to Pune cab services for travelers looking for a seamless, safe, and hassle-free journey between the city of Mumbai and Pune. Whether you are traveling for business, attending conferences, family trips, weekend getaways, or group tours, our cab service ensures a smooth ride with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in highway driving, punctual pickups from Mumbai Airport, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai Airport to Pune cab services.",

topPlaces: [
  {
    title: "Shaniwar Wada",
    description:
      "Shaniwar Wada is a historic fortification in Pune, renowned for its architectural grandeur and historical significance as the seat of the Peshwas of the Maratha Empire. Visitors can explore the fort’s gates, gardens, and learn about its history. Traveling by cab from Mumbai Airport ensures a comfortable journey and ample time to enjoy this cultural landmark without worrying about city transport."
  },
  {
    title: "Aga Khan Palace",
    description:
      "Aga Khan Palace is a majestic palace with historical significance, known for its association with Mahatma Gandhi and the Indian freedom struggle. Visitors can explore the museum, peaceful gardens, and architecture. A cab ride from Mumbai Airport allows travelers to reach the palace conveniently and spend sufficient time exploring its serene surroundings."
  },
  {
    title: "Sinhagad Fort",
    description:
      "Sinhagad Fort, located near Pune, is a popular trekking and historical site offering panoramic views of the Sahyadri hills. Visitors can enjoy trekking, photography, and learning about the fort’s historical importance. Traveling by cab ensures a safe and hassle-free journey from Mumbai Airport, providing flexibility to plan a full day excursion."
  },
  {
    title: "Dagdusheth Halwai Ganapati Temple",
    description:
      "This famous temple in Pune is dedicated to Lord Ganesha and attracts thousands of devotees and tourists. Visitors can witness religious rituals, admire the intricate architecture, and capture photographs. A cab ride from Mumbai Airport ensures convenient access, allowing travelers to integrate spiritual exploration with sightseeing."
  },
  {
    title: "Pataleshwar Cave Temple",
    description:
      "Pataleshwar is an ancient rock-cut temple dedicated to Lord Shiva, offering a peaceful atmosphere in the heart of Pune. Visitors can explore the caves, learn about historical architecture, and enjoy photography. Traveling by cab ensures comfortable transport from Mumbai Airport and flexible scheduling for sightseeing."
  },
  {
    title: "Osho Ashram",
    description:
      "Osho Ashram in Pune is a renowned meditation and spiritual center, attracting visitors seeking relaxation and self-reflection. Guests can participate in meditation sessions, explore the ashram gardens, and experience a tranquil environment. A cab ride provides hassle-free access from Mumbai Airport and a comfortable journey for spiritual seekers."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description:
      "This museum houses an extensive collection of Indian artifacts, artworks, and cultural exhibits. Visitors can explore galleries, take photographs, and learn about India’s rich heritage. Traveling by cab ensures easy access from Mumbai Airport, allowing tourists to include this cultural attraction efficiently."
  },
  {
    title: "Koregaon Park",
    description:
      "Koregaon Park is a vibrant neighborhood in Pune known for cafes, boutique stores, and cultural experiences. Visitors can enjoy shopping, dining, and leisurely walks amidst greenery. A cab ride from Mumbai Airport provides convenient transport, enabling tourists to combine urban exploration with sightseeing."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description:
      "Also known as Pu La Deshpande Garden, this Japanese-style garden offers serene landscapes, water features, and walking paths. Visitors can enjoy photography, relaxation, and scenic beauty. Traveling by cab ensures comfortable access from Mumbai Airport, allowing travelers to unwind amidst nature."
  },
  {
    title: "Vetal Tekdi",
    description:
      "Vetal Tekdi is a hill in Pune offering panoramic city views, trekking opportunities, and nature walks. Visitors can enjoy photography, exercise, and fresh air. A cab ride from Mumbai Airport ensures a safe and comfortable journey, making it easy to plan a mix of urban sightseeing and outdoor activities."
  }
],




services: [
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai Airport to Pune cab service offers comfortable and reliable airport transfer between Mumbai International Airport and Pune city. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys via the Mumbai–Pune Expressway. Professional drivers track flight timings to ensure punctual pickup from Terminal 1 and Terminal 2. Pickup services are available directly from the airport arrival gate. Ideal for corporate travelers, tourists, and family travel. Spacious seating and air-conditioned interiors ensure relaxed travel after a long flight. Flexible one-way and round-trip options are available for convenient planning. Transparent pricing ensures a smooth and stress-free airport cab experience."
},
{
name: "Mumbai Airport to Pune Taxi",
description: "Mumbai Airport to Pune taxi service provides dependable airport transportation for travelers arriving in Mumbai. Comfortable AC vehicles ensure pleasant travel across the Mumbai–Pune Expressway route. Experienced drivers ensure safe driving and timely arrival in Pune. Pickup services are available from both domestic and international terminals of Mumbai Airport. Ideal for business travelers, tourists, and families traveling to Pune. Clean interiors and spacious seating ensure comfortable journeys. Flexible departure timing allows travelers to start their journey immediately after arrival. Reliable taxi services ensure safe and convenient airport transfers."
},
{
name: "Mumbai Airport to Pune Cab Service",
description: "Mumbai Airport to Pune cab service offers reliable long-distance airport transfers for passengers traveling to Pune city. Our well-maintained AC vehicles ensure smooth highway journeys and comfortable seating. Professional drivers provide safe driving and punctual pickup from the airport. Pickup is available from Mumbai Airport terminals with easy meeting points. Ideal for corporate travel, hotel transfers, and family journeys. Spacious interiors provide relaxed seating during the journey. Flexible booking options allow travelers to schedule rides in advance. Transparent pricing ensures dependable cab service."
},
{
name: "Mumbai Airport to Pune Taxi Service",
description: "Mumbai Airport to Pune taxi service offers efficient transportation from Mumbai Airport to Pune city. Our fleet includes AC sedans and SUVs suitable for long-distance highway travel. Skilled drivers ensure safe driving and timely drop at your destination. Pickup services are available from Terminal 1 and Terminal 2 arrival areas. Ideal for business travelers, tourists, and airport transfers. Spacious seating ensures passenger comfort throughout the journey. Flexible scheduling options allow convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai Airport to Pune",
description: "Cab from Mumbai Airport to Pune offers private and comfortable transportation for passengers arriving at Mumbai Airport. AC vehicles ensure smooth travel along the Mumbai–Pune Expressway route. Professional drivers ensure safe driving and reliable service throughout the journey. Pickup services are available directly from airport arrival gates. Ideal for families, corporate travelers, and tourists visiting Pune. Spacious interiors ensure comfortable seating during long-distance travel. Flexible departure timing allows convenient travel planning. Reliable cab services ensure stress-free airport transfers."
},
{
name: "Taxi from Mumbai Airport to Pune",
description: "Taxi from Mumbai Airport to Pune provides dependable airport transfer services for travelers heading to Pune city. Comfortable AC vehicles ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe driving and timely arrival at your destination. Pickup services are available from domestic and international terminals of Mumbai Airport. Ideal for corporate travelers, tourists, and family trips. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy trip planning. Professional taxi services ensure reliable airport transportation."
},
{
name: "Mumbai Airport to Pune Cab Booking",
description: "Mumbai Airport to Pune cab booking allows travelers to reserve vehicles easily for airport transfers. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup from the airport arrival terminal. Pickup services are available from both domestic and international terminals. Ideal for corporate travel, hotel transfers, and family trips. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free airport travel."
},
{
name: "Mumbai Airport to Pune Taxi Booking Online",
description: "Mumbai Airport to Pune taxi booking online provides quick and convenient reservations for travelers arriving at Mumbai Airport. Instant booking confirmation helps passengers schedule rides easily. Comfortable AC vehicles ensure relaxed highway travel conditions. Experienced drivers ensure safe and professional driving services. Pickup services are available from Terminal 1 and Terminal 2. Ideal for business travelers and families traveling to Pune. Flexible travel timing allows convenient trip scheduling. Reliable online booking ensures smooth taxi reservations."
},
{
name: "Mumbai Airport to Pune Cab Price",
description: "Mumbai Airport to Pune cab price offers transparent and affordable travel options for airport transfers. Clear pricing details allow travelers to understand total trip costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel after flight arrival. Professional drivers ensure safe highway travel and punctual drop in Pune. Pickup services are available across Mumbai Airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai Airport to Pune Taxi Fare",
description: "Mumbai Airport to Pune taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth travel along the Mumbai–Pune Expressway. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from both domestic and international terminals. Ideal for business trips and family travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai Airport to Pune One Way Cab",
description: "Mumbai Airport to Pune one way cab service is ideal for travelers who require a direct drop without return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for highway journeys. Professional drivers ensure safe driving and punctual pickup from the airport. Pickup services are available from Terminal 1 and Terminal 2. Ideal for corporate travel, tourists, and family trips. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable airport transfers."
}
],

tableData: [
["Mumbai Airport to Pune Cab","Mumbai Airport to Pune Taxi"],
["Mumbai Airport to Pune Cab Service","Mumbai Airport to Pune Taxi Service"],
["Cab from Mumbai Airport to Pune","Taxi from Mumbai Airport to Pune"],
["Mumbai Airport to Pune Cab Booking","Mumbai Airport to Pune Taxi Booking Online"],
["Mumbai Airport to Pune Cab Price","Mumbai Airport to Pune Taxi Fare"],
["Mumbai Airport to Pune One Way Cab","Best Airport Cab Mumbai to Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Our drivers are experienced in airport pickups and highway travel between Mumbai Airport and Pune. They track flight timings, understand airport terminals, and ensure timely pickups so passengers enjoy a smooth journey to Pune."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai Airport to Pune cab bookings. We clearly explain per-kilometer fares, toll charges, and travel packages before confirming the trip so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Flights arrive at all hours, which is why Omshree Cabs provides 24/7 cab booking and customer support for Mumbai Airport to Pune travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable ride from Mumbai Airport to Pune."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way airport transfers, round-trip bookings, and same-day return services for Mumbai Airport to Pune journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for solo travelers, families, and corporate passengers."
  },
  {
    WhyChooseheading: "Pickup from All Mumbai Airport Terminals",
    WhyChoosedescription: "We provide convenient pickup from Terminal 1 and Terminal 2 of Mumbai Airport. Our drivers monitor flight arrival times and wait for passengers so your transfer to Pune begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Airport Transfer Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai Airport to Pune cab services. Our punctual drivers, comfortable vehicles, and professional service ensure a safe and stress-free airport transfer."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai Airport to Pune by cab?", answer: "The distance from Mumbai Airport to Pune is approximately 150 km and the journey usually takes around 3–4 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai Airport to Pune cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services from Mumbai Airport to Pune." },
  { question: "Which vehicles are available for Mumbai Airport to Pune travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your comfort preference and group size." },
  { question: "Do you provide pickup from Terminal 1 and Terminal 2?", answer: "Yes, Omshree Cabs provides airport pickup from both Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Will the driver wait if my flight is delayed?", answer: "Yes, our drivers monitor flight timings and adjust pickup times accordingly to avoid inconvenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request short stops during the journey for refreshments or rest." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel hours." },
  { question: "Do you provide corporate airport transfer services?", answer: "Yes, Omshree Cabs provides corporate and business airport transfer services between Mumbai Airport and Pune." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Kulkarni",
    feedback:
      "I booked Omshree Cabs for my Mumbai Airport to Pune transfer. The driver was waiting on time and the car was very comfortable. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshpande",
    feedback:
      "Our airport pickup from Mumbai to Pune with Omshree Cabs was smooth and hassle-free. The vehicle was clean and the driver was very professional.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cabs",
  "description": "Book Mumbai Airport to Pune Cabs with Omshree Cab for safe and comfortable travel. Reliable taxi service from Mumbai Airport to Pune with one-way options. Affordable fares, easy online cab booking, and trusted cab service for airport transfers.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2250"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport to Pune Cabs | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune Cabs with Omshree Cab for comfortable travel. Taxi service from Mumbai Airport to Pune with one-way options. Affordable fares and easy online cab booking for your airport transfer." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecab;